import axios from "axios";

const request = axios.create({
  baseURL: "",
  withCredentials: true,
});

if (process.env.NODE_ENV === "development") {
  document.cookie = "llsid=60d240f8-afd5-49ce-85d0-f61318d8ebd1";
}

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("error", error);
  }
);

export default request;
